import { render } from "./UserSearchBox.vue?vue&type=template&id=6ed9a3f6&scoped=true"
import script from "./UserSearchBox.vue?vue&type=script&lang=js"
export * from "./UserSearchBox.vue?vue&type=script&lang=js"

import "./UserSearchBox.vue?vue&type=style&index=0&id=6ed9a3f6&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed9a3f6"]])

export default __exports__